module.exports = __webpack_public_path__ + "31f9effcf2778477d6f1a2bf8b93eec2.svg";